import React from 'react';
import 'assets/css/componentStyles/Loader.css';
import spinner from 'assets/img/spinner.gif';

function InfinityLoader() {
  return (
    <div className="infinity-loader-wrapper">
      <div className="infinity-loader">
        <img className="infinity-loader-img" src={spinner} alt="Loading..." />
      </div>
    </div>
  );
}

export default InfinityLoader;
